export default {
    LOAD_SPOT(state, spot) {
        state.items = spot
    }
}